import ListItemIcon from "@material-ui/core/ListItemIcon";
import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";
import ArrowDownwardIcon from "@material-ui/icons/ArrowDownward";
import RenameIcon from "@material-ui/icons/Create";
import DeleteIcon from "@material-ui/icons/Delete";
import DownloadIcon from "@material-ui/icons/OpenInNew";
import React from "react";
import { useTranslate } from "react-admin";

import { downloadBlob, ensureResponseOk } from "utils/download";
import { useNotifyError } from "utils/notifiers/useNotifyError";

import { httpClientRaw } from "../../../../api/httpClient";
import { fetchDataForExport } from "../../../dialogs/ExportDialog/DataExportTable";
import { LoadingSpinner } from "../../../LoadingSpinner";
import { DocumentEditDialog } from "./DocumentEditDialog";

export const DocumentItemMenu = ({ typeChoices, ...props }) => {
	const translate = useTranslate();
	const notifyError = useNotifyError();
	const [loading, setLoading] = React.useState(false);
	const [anchorEl, setAnchorEl] = React.useState(null);

	const [isModalOpen, setIsModalOpen] = React.useState(false);
	const handleCloseModal = () => setIsModalOpen(false);

	const open = React.useMemo(() => Boolean(anchorEl), [anchorEl]);

	const handleClick = React.useCallback((event) => {
		setAnchorEl(event.currentTarget);
	}, []);

	const handleClose = React.useCallback(() => {
		setAnchorEl(null);
	}, []);

	const handleEdit = () => {
		setIsModalOpen(true);
		handleClose();
	};

	const handleFullDownload = () => {
		setLoading(true);
		fetchDataForExport(httpClientRaw, "documents-output", { id: props.document.id }, "xlsx")
			.then(async (res) => {
				await ensureResponseOk(res);
				return res.blob();
			})
			.then((blobby) => {
				setLoading(false);
				const outputDocName = props.document.title ? props.document.title : "_";
				downloadBlob(blobby, `${outputDocName}_full_out_doc.xlsx`);
			})
			.catch((err) => {
				notifyError(err);
			})
			.finally(() => {
				handleClose();
				setLoading(false);
			});
	};

	const handleDelete = () => {
		props.handleDelete && props.handleDelete(props.document);
		handleClose();
	};

	// const isCustomerDriver = props.permissions && (
	// 	props.permissions.role === UserRole.customer_and_transporter_driver
	// );
	// const isTransporterCompany = props.permissions && (
	// 	props.permissions.role === UserRole.transporter_manager ||
	// 	props.permissions.role === UserRole.transporter_employee ||
	// 	props.permissions.role === UserRole.transporter_driver
	// );

	return (
		<React.Fragment>
			{React.cloneElement(props.children, { onClick: handleClick })}
			{isModalOpen && (
				<DocumentEditDialog
					open={isModalOpen}
					handleClose={handleCloseModal}
					doc={props.document}
					handleSave={props.handleUpdate}
					typeChoices={typeChoices}
				/>
			)}
			<Menu anchorEl={anchorEl} open={open} onClose={handleClose}>
				<MenuItem dense component="a" href={props.document.preview_src} target="_blank">
					<ListItemIcon>
						<DownloadIcon fontSize="small" />
					</ListItemIcon>
					{translate("osfc.fields.document.download")}
				</MenuItem>
				{props.isOutputDocuments && (
					<MenuItem dense onClick={handleFullDownload}>
						<ListItemIcon>
							<ArrowDownwardIcon fontSize="small" />
						</ListItemIcon>
						{translate("osfc.fields.document.full_download")}
					</MenuItem>
				)}
				{!props.isReadOnly && !props.isOutputDocuments && (
					<MenuItem dense onClick={handleEdit}>
						<ListItemIcon>
							<RenameIcon fontSize="small" />
						</ListItemIcon>
						{translate("osfc.fields.document.edit")}
					</MenuItem>
				)}
				{!props.isReadOnly && (
					<MenuItem dense onClick={handleDelete}>
						<ListItemIcon>
							<DeleteIcon fontSize="small" />
						</ListItemIcon>
						{translate("osfc.fields.document.delete")}
					</MenuItem>
				)}
				{props.isOutputDocuments && loading && <LoadingSpinner />}
			</Menu>
		</React.Fragment>
	);
};
